<!-- Salt Type Selection Dialog -->
      <p-dialog [(visible)]="showSaltTypeDialog" [modal]="true" [style]="{width: '400px'}" 
                [closeOnEscape]="false" [closable]="false" header="Select Salt Type">
        
        <div class="flex flex-column gap-4 p-4">
          <p class="text-center mb-3">
            This trailer is being loaded with salt. Please specify the type:
          </p>
          
          <div class="flex flex-column gap-2">
            <label for="saltType" class="font-medium">Salt Type:</label>
            <p-dropdown 
              id="saltType"
              [options]="saltTypeOptions" 
              [(ngModel)]="selectedSaltType" 
              optionLabel="label" 
              optionValue="value"
              placeholder="Select salt type"
              [style]="{'width': '100%'}"
              [appendTo]="'body'">
            </p-dropdown>
          </div>
        </div>

        <ng-template pTemplate="footer">
          <div class="flex justify-content-end gap-2">
            <button pButton 
                    label="Cancel" 
                    icon="pi pi-times" 
                    class="p-button-outlined"
                    (click)="cancelSaltType()">
            </button>
            <button pButton 
                    label="Confirm" 
                    icon="pi pi-check"
                    (click)="confirmSaltType()">
            </button>
          </div>
        </ng-template>
      </p-dialog>
